import { Vue  } from 'vue-property-decorator';
import VueKatex from 'vue-katex';
import 'katex/dist/katex.min.css';


Vue.use(VueKatex, {
    globalOptions: {
        delimiters: [{ left: '$$', right: '$$', display: false }],
    },
  });

